import { render, staticRenderFns } from "./footerTop.vue?vue&type=template&id=0262654d&scoped=true&"
import script from "./footerTop.vue?vue&type=script&lang=js&"
export * from "./footerTop.vue?vue&type=script&lang=js&"
import style0 from "./footerTop.vue?vue&type=style&index=0&id=0262654d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0262654d",
  null
  
)

export default component.exports